// extracted by mini-css-extract-plugin
export default {"title":"Title_title__w+Z-5","line":"Title_line__pQDLt"};